import type { ComponentStyleConfig } from '@chakra-ui/theme';

const Result: ComponentStyleConfig = {
  parts: ['Container', 'StatusIcon', 'Title', 'SubTitle', 'Extra', 'Children'],
  baseStyle: {
    Container: {
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      py: 6,
    },
    StatusIcon: {
      fontSize: '72px',
      mb: 4,
    },
    Title: { fontSize: '2xl' },
    SubTitle: { fontSize: 'sm', color: 'gray.500' },
    Extra: { mt: 4, gap: 4 },
    Children: { p: 4 },
  },
};

export default Result;
